import { Injectable, OnInit } from '@angular/core';
import { LocationItem } from './common/locations.model';

/* Store the state of the search center and radius as well as a reference to the Google map for components to use.
   The latitude, longitude, and radius should always match up with the latest search.  */
@Injectable()
export class LocationStateService implements OnInit {
  private latitude: number;
  private longitude: number;
  private radius: number;
  private map: any;
  private locations: LocationItem[];
  private url: string;
  private zoom: number;
  private healthCenter: string;
  private checkboxData?: { name: string; value: boolean }[];
  private apiMethod: string;

  get Latitude() {
    return this.latitude;
  }

  set Latitude(value) {
    this.latitude = value;
  }

  get Longitude() {
    return this.longitude;
  }

  set Longitude(value) {
    this.longitude = value;
  }

  get Radius() {
    return this.radius;
  }

  set Radius(value) {
    this.radius = value;
  }

  get Map() {
    return this.map;
  }

  set Map(value) {
    this.map = value;
  }

  get Locations() {
    return this.locations;
  }

  set Locations(value) {
    this.locations = value;
  }

  get Url() {
    return this.url;
  }

  set Url(value) {
    this.url = value;
  }

  get Zoom() {
    return this.zoom;
  }

  set Zoom(value) {
    this.zoom = value;
  }

  get HealthCenter() {
    return this.healthCenter;
  }

  set HealthCenter(value) {
    this.healthCenter = value;
  }

  get CheckboxData() {
    return this.checkboxData;
  }

  set CheckboxData(value) {
    this.checkboxData = value;
  }

  get ApiMethod() {
    return this.apiMethod;
  }

  set ApiMethod(value) {
    this.apiMethod = value;
  }

  constructor() {}

  public ngOnInit(): void {}
}
